import script from "./SMSCampaignsHeaderCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSCampaignsHeaderCreate.vue?vue&type=script&setup=true&lang=ts"

import "./SMSCampaignsHeaderCreate.vue?vue&type=style&index=0&id=3c7a71d5&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c7a71d5"]])

export default __exports__